import {IStateMain} from './reducer';
import {ITorosInfo} from '../../../common/type';
import {
  createAction,
  createActionFetch,
  createBasicActions,
} from '../../../common/util/redux';
import {IBigContent} from '../../../commonSub/type';
import {
  IRankingTabContents,
  IRecommendContentCard,
  ISpecialCard,
  IWaitfreeInfo,
} from '../type';

export enum ActionType {
  SetValue = 'main.SetValue',
  SetPropertyValues = 'main.SetPropertyValues',
  FetchRecommendList = 'main.FetchRecommendList',
  FetchSpecialList = 'main.FetchSpecialList',
  FetchSpecialContent = 'main.FetchSpecialContent',
  FetchWaitfreeList = 'main.FetchWaitfreeList',
  FetchMainList = 'main.FetchMainList',
  FetchRankingTabContents = 'main.FetchRankingTabContents',
  SetRankingTabContents = 'main.SetRankingTabContents',
  SetMainContents = 'main.SetMainContents',
}

export const actions = {
  ...createBasicActions<IStateMain>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  fetchRecommendList: () => createActionFetch(ActionType.FetchRecommendList),
  fetchSpecialList: () => createActionFetch(ActionType.FetchSpecialList),
  fetchSpecialContent: (id: number) =>
    createActionFetch(ActionType.FetchSpecialContent, {payload: {id}}),
  fetchWaitfreeList: () => createActionFetch(ActionType.FetchWaitfreeList),
  fetchMainList: () => createActionFetch(ActionType.FetchMainList),
  fetchRankingTabContents: ({
    tag,
    isRealTimeRankingTab,
  }: {
    tag?: string;
    isRealTimeRankingTab: boolean;
  }) =>
    createActionFetch(ActionType.FetchRankingTabContents, {
      payload: {tag, isRealTimeRankingTab},
      fetchKey: tag,
    }),
  setRankingTabContents: (payload: IRankingTabContents) =>
    createAction(ActionType.SetRankingTabContents, payload),
  setMainContents: ({
    recommends = {items: []},
    specials = [],
    waitfrees = {contents: [], waitfreeInfo: {hours: 0, episodeCount: 0}},
  }: {
    recommends?: {items: IRecommendContentCard[]; torosInfo?: ITorosInfo};
    specials?: ISpecialCard[];
    waitfrees?: {contents: IBigContent[]; waitfreeInfo: IWaitfreeInfo};
  }) =>
    createAction(ActionType.SetMainContents, {
      recommends,
      specials,
      waitfrees,
    }),
};
